import { useEffect, useState } from "react";
import { Mic, MicOff } from "lucide-react";
import { getMicStatus } from "@/lib/micGate";

export const MicReadyBadge = () => {
  const [s, setS] = useState(getMicStatus);
  useEffect(() => { const h = () => setS(getMicStatus()); window.addEventListener("lexv-mic-status", h); return () => window.removeEventListener("lexv-mic-status", h); }, []);
  if (!s) return null;
  const ok = s === "ready";
  return (
    <span data-testid="mic-ready-badge" data-status={s} title={ok ? "Microphone and speakers checked for this visit" : "Microphone disconnected. It will be checked again when you start."}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-bold transition-colors ${ok ? "bg-emerald-500/15 text-emerald-300 ring-1 ring-emerald-500/40" : "bg-slate-700 text-slate-200 ring-1 ring-slate-500"}`}>
      {ok ? <Mic className="h-3 w-3" /> : <MicOff className="h-3 w-3" />}<span className="hidden sm:inline">{ok ? "Mic ready" : "Mic off"}</span>
      {ok && <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400" />}
    </span>
  );
};
